import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_UNLOCKING_HISTORY_API} from '@app/reactQuery/apis/constants';

export const RQUseGetUnlockingHistoryData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_unlocking_history_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_UNLOCKING_HISTORY_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};
